module.exports = __webpack_public_path__ + "static/img/S02.bac2d4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/S02.jpg
// module id = AyvL
// module chunks = 9